<!-- Middle Content CSS End Here  -->
<div class="middle-content-wrap">
    <!-- Dashboard HTML Start Here  -->
    <div class="globalheading dflex dflex_bet">
        <h2>Push Notification</h2>
        <div class="addbtnhead">
            <div class="page-header-right">
                <div class="common_btn">
                    <a href="javascript:void(0);" routerLink="/push-notification-add"><button class="add-user-btn"
                           ><img src="assets/images/plus.svg" alt=""> Add
                            New</button></a>
                </div>
            </div>

        </div>
    </div>
    <div class="listingformat">

        <div class="tabledatawrap preferences-table">
            <table>
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Message</th>
                        <th>Date and Time</th>
                        <th>Customer Type</th>
                        <th>Sent To</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of notificationList | paginate: {id: 'delivered', itemsPerPage: total, currentPage: p , totalItems: count};let i = index;">
                        <td class="minwidth300">{{item.title}}</td>
                        <td  class="minwidth300">{{item.notification_message}}</td>
                        <td>{{item.createdAt | date:'short'}}</td>
                        <td *ngIf="item.notification_user_type == 'Verified_user'; else secondTd">Verified User</td>
                        <ng-template #secondTd>
                            <td *ngIf="item.notification_user_type == 'Non_verified_user'else thirdTd">
                                Non Verified User
                            </td>
                        </ng-template>
                        <ng-template #thirdTd>
                            <td>
                                {{item.notification_user_type}}
                            </td>
                        </ng-template>
                        <td>{{item.total_users}} Users</td>
                    </tr>
                </tbody>
                <tbody *ngIf="notificationList?.length == 0">
                    <tr>
                        <td colspan="12">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 custompagination">
                <pagination-controls class="" id="delivered" (pageChange)="onTableDataChange($event)">
                </pagination-controls>
            </div>
        </div>
    </div>
    <!-- Dashboard HTML End Here  -->
</div>
<!-- Middle Content CSS End Here  -->

<!-- Delete Popup -->
<!-- <div class="modal fade bd-example-modal-sm common_modal" id="deletModal" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Delete
                </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <p>Are you sure you want to delete this?</p>
                    <div class="common_btn">
                        <button data-dismiss="modal">Cancel</button>
                        <button (click)="deletePop()">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Delete Popup -->
